import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confirmation-reset-password-dialog',
  templateUrl: './confirmation-reset-password-dialog.component.html',
  styleUrls: ['./confirmation-reset-password-dialog.component.css']
})
export class ConfirmationResetPasswordDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public location: Location,
    public route: ActivatedRoute) { }

  ngOnInit() {
  }
  public saveAndClose = () => {
    this.dialogRef.close(this.data);
  }
  public onNoClick = () => {
    this.dialogRef.close();
  }
}
